<template>
    <div>
        <header id="header">
            <div class="container">
                <div class="">
                    <h1 class="h1">{{ group.name }}</h1>
                </div>
                <div class="actions">          
                    <router-link class="btn btn-small" :to="{ name: 'edit-group'}" v-if="group.can.edit">Group settings</router-link>
                    <a v-on:click.stop.prevent="openModal('new-category')" href="#" class="btn btn-primary btn-small">Add a category</a>
                    <category-modal :category="new_category" categoryType="category" v-on:new-category="insertCategory"></category-modal>
                </div>
            </div>
            <nav class="container">
            </nav>
        </header>

        <div class="container category-list">
            <div class="grid">
                <div class="col-md-12" v-for="cat in group.categories" v-bind:key="cat.id">
                    <div class="grid">
                        <div class="col-md-3">
                            <h2><router-link :to="{ name: 'view-category', params: { group: group.slug, category: cat.slug }}">{{ cat.name }}</router-link> <small>{{ cat.posts_count }}</small></h2>
                        </div>
                        <div class="col-md-9">
                            <div class="grid">
                                <div class="col-md-3" v-for="post in cat.posts.slice(0,3)" v-bind:key="post.id">
                                    <post-card-category :post="post" :group="group" :category="cat"></post-card-category>
                                </div>
                                <div class="col-md-3" v-if="cat.posts.length > 3">
                                    <div class="card card--news">
                                        <router-link :to="{ name: 'view-category', params: { group: group.slug, category: cat.slug }}">View all</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MicroModal from 'micromodal';
    export default {
        props: ['group', 'post'],
        data(){
            return {
                is_admin: window.user_can.admin,
                new_category: null,
            }
        },
        methods: {
            openModal(modal){
                MicroModal.show(modal);
            },
            updateCategories(cat){
                this.group.categories.forEach((cat, index) => {
                    if(cat.id === cat.id) {
                        this.$set(this.group.categories, index, cat);
                    }
                });
            },
            insertCategory(cat){
                this.$set(this.group.categories, this.group.categories.length, cat);
            },
            updateCategories(cat){
                this.group.categories.forEach((cat, index) => {
                    if(cat.id === cat.id) {
                        this.$set(this.group.categories, index, cat);
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .category-list h2 a{
        color: #546b81;
        text-decoration: none;
    }
    .category-list h2 a:hover{
        text-decoration: underline;
    }
    .category-list h2 small{
        color: #bbbbbb;
        font-size: 1em;
        margin-left: 0.2rem;
    }
</style>